import http from '../http-common';

export default {
  getContacts(days = 7) {
    return http.get(`/ai-validation/contacts?days=${days}`);
  },
};
